/**
 * @generated SignedSource<<aa2503a8ad6b351d6c052591d78c4b50>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GroupPickerGroupHeader$data = {
  readonly group: {
    readonly name: string;
  };
  readonly " $fragmentType": "GroupPickerGroupHeader";
};
export type GroupPickerGroupHeader$key = {
  readonly " $data"?: GroupPickerGroupHeader$data;
  readonly " $fragmentSpreads": FragmentRefs<"GroupPickerGroupHeader">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "GroupPickerGroupHeader",
  "selections": [
    {
      "concreteType": "JiraGroup",
      "kind": "LinkedField",
      "name": "group",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "name"
        }
      ]
    }
  ],
  "type": "JiraJqlGroupFieldValue"
};

(node as any).hash = "08fb8e73749f71d49ccd999fc7f864e0";

export default node;
